import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AuthService } from '../auth/auth.service';
import { LoadingModule } from 'ngx-loading';
import { SharedModule } from '../shared/shared.module';
import { CustomerReportoutingModule } from './customer-report-routing.module';
import { CustomerReportComponent } from './customer-report.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    LoadingModule,
    CustomerReportoutingModule,
    ReactiveFormsModule,
    SharedModule
  ],
  declarations: [CustomerReportComponent],
  providers: [AuthService]
})
export class CustomerReportModule { }



// WEBPACK FOOTER //
// ./src/app/customer-report/customer-report.module.ts